<div *ngIf="rfqService.activeRecord$ | async as rfq">
  <!-- <div class="kt-subheader kt-grid__item" id="kt_subheader">
        <div class="kt-subheader__main">
            <h3 class="kt-subheader__title ng-star-inserted">
                <label for="" [translate]="'TITLES.QUOTATION_FOR'"> Quotations for: </label>
                <a href="javascript:;" title="Show details" (click)="showDetails()"> {{ rfq.product_name }} </a>
            </h3>
            <h4 class="kt-subheader__desc ng-star-inserted">{{ rfq.product_category }}</h4>
        </div>
        <div class="kt-subheader__toolbar">
            <h5>
                <button class="btn btn-brand" (click)="addQuotation()" [translate]="'BUTTONS.ADD_NEW_QUOTATION'">
                    <i class="fas fa-plus"></i> Add New Quotation
                </button>
                <button class="btn btn-info" (click)="viewClientInfo()" [translate]="'BUTTONS.VIEW_CLIENT_INFO'">
                    <i class="fas fa-user-tie"></i> View Client Info
                </button>
            </h5>
        </div>
    </div> -->

  <div class="kt-portlet">
    <div class="kt-portlet__head">
      <div class="kt-portlet__head-label">
        <h3 class="kt-portlet__head-title">
          <label for="" [translate]="'TITLES.QUOTATION_FOR'">
            Quotations for:
          </label>
          <a href="javascript:;" title="Show details" (click)="showDetails()">
            {{ rfq.product_name }}
            <small class="ml-2">{{ rfq.product_category }}</small>
          </a>
        </h3>
      </div>
      <div class="kt-portlet__head-toolbar">
        <button
          class="btn btn-brand mr-2"
          (click)="addQuotation()"
          [translate]="'BUTTONS.ADD_NEW_QUOTATION'"
        >
          <i class="fas fa-plus"></i> Add New Quotation
        </button>
        <button
          class="btn btn-info"
          (click)="viewClientInfo()"
          [translate]="'BUTTONS.VIEW_CLIENT_INFO'"
        >
          <i class="fas fa-user-tie"></i> View Client Info
        </button>
      </div>
    </div>

    <kt-portlet-body *ngIf="quotesService.record$ | async as qRecord">
      <div class="quotation-block">
        <table
          class="table table-hover"
          *ngIf="settingsSvc.masterfile$ | async as settings"
        >
          <thead>
            <tr>
              <th width="30">&nbsp;</th>
              <th width="120">&nbsp;</th>
              <th class="text-center" [translate]="'TITLES.COUNTRY'">COUNTRY</th>
              <th [translate]="'TITLES.TIERED_PRICING'">TIERED PRICING</th>
              <th [translate]="'TITLES.LEAD_TIME'" class="text-center" width="120"
                >LEAD TIME</th
              >
              <th
                [translate]="'TITLES.SAMPLE_DETAILS'"
                class="text-center"
                width="120"
                >SAMPLE DETAIL</th
              >
              <th [translate]="'TITLES.QUOTATION_NOTES'">NOTES</th>
              <th [translate]="'TITLES.FILES'">FILES</th>
              <th [translate]="'TITLES.STATUS'" width="150" class="text-center"
                >STATUS</th
              >
              <th width="80">&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="quotesService.gettingRecords">
              <td colspan="9" class="text-center">
                <br />
                <h6 [translate]="'GENERAL.GETTING_RECORDS'">
                  <i class="fas fa-spinner fa-spin"></i> Getting records...
                </h6>
                <br />
              </td>
            </tr>
            <tr *ngFor="let r of qRecord.data; let i = index">
              <td align="center" valign="middle">
                <h1>{{ i + 1 }}</h1>
              </td>
              <td align="center" width="150">
                <img
                  [src]="url + '/file?f=' + (r.photo != '' ? r.photo : noImgUrl)"
                  width="150"
                  alt=""
                />
              </td>
              <td>
                <h4 class="text-center text-capitalize">{{ r.country }}</h4>
              </td>
              <td>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th [translate]="'GENERAL.QUANTITY'">QUANTITY</th>
                      <th *ngIf="r.logistic_1">
                        {{ settings.LOGISTICS[r.logistic_1] | translate }}
                      </th>
                      <th *ngIf="r.logistic_2">
                        {{ settings.LOGISTICS[r.logistic_2] | translate }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let tp of r.tiered_pricing_json; let i = index">
                      <td>{{ tp.quantity }}</td>
                      <td *ngIf="r.logistic_1">
                        {{ tp.logistic_1 | currency: '' : 'symbol' : '1.2-4' }}
                      </td>
                      <td *ngIf="r.logistic_2">
                        {{ tp.logistic_2 | currency: '' : 'symbol' : '1.2-4' }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td align="center">
                <div class="lead-time" *ngIf="r.logistic_1">
                  <div class="days"
                    >{{
                      settingsSvc.getLeadTime(r.logistic_1, r.lead_time_days_log1)
                    }}
                    {{ 'GENERAL.DAYS' | translate }}</div
                  >
                  <div class="desc">{{
                    settings.LOGISTICS[r.logistic_1] | translate
                  }}</div>
                </div>
                <br />
                <div class="lead-time" *ngIf="r.logistic_2">
                  <div class="days"
                    >{{
                      settingsSvc.getLeadTime(r.logistic_2, r.lead_time_days_log1)
                    }}
                    {{ 'GENERAL.DAYS' | translate }}</div
                  >
                  <div class="desc">{{
                    settings.LOGISTICS[r.logistic_2] | translate
                  }}</div>
                </div>
              </td>
              <td align="center">
                <div class="lead-time">
                  <div class="days">{{
                    r.sample_price | currency: '' : 'symbol' : '1.2-4'
                  }}</div>
                  <div class="desc">{{ 'GENERAL.PRICE' | translate }}</div>
                </div>
                <br />
                <div class="lead-time">
                  <div class="days">{{ r.sample_lead_time_days }} days</div>
                  <div class="desc">{{ 'TITLES.LEAD_TIME' | translate }}</div>
                </div>
              </td>
              <td>{{ r.notes }}</td>
              <td>
                <ul *ngFor="let file of r.files; let fidx = index">
                  <li *ngIf="file != ''">
                    <a [attr.href]="url + '/file?f=' + file" target="_blank"
                      >File {{ fidx + 1 }}</a
                    >
                  </li>
                </ul>
              </td>
              <td class="text-center">
                <span
                  *ngIf="r.status == 1"
                  class="kt-badge kt-badge--warning kt-badge--inline kt-badge--md"
                  [translate]="'QUOTE_STATUS.DRAFT'"
                >
                  DRAFT</span
                >
                <span
                  *ngIf="r.status == 2"
                  class="kt-badge kt-badge--info kt-badge--inline kt-badge--md"
                  [translate]="'QUOTE_STATUS.POSTED'"
                >
                  POSTED</span
                >
                <span
                  *ngIf="r.status == 4"
                  class="kt-badge kt-badge--info kt-badge--inline kt-badge--md"
                  [translate]="'QUOTE_STATUS.NEGOTIATED_PRICE'"
                >
                  POSTED</span
                >
                <span
                  *ngIf="r.status == 8"
                  class="kt-badge kt-badge--info kt-badge--inline kt-badge--md"
                  [translate]="'QUOTE_STATUS.SAMPLE_ORDERED'"
                >
                  POSTED</span
                >
                <span
                  *ngIf="r.status == 16"
                  class="kt-badge kt-badge--info kt-badge--inline kt-badge--md"
                  [translate]="'QUOTE_STATUS.ORDER_PLACED'"
                >
                  POSTED</span
                >
                <br /><br />
                <button
                  *ngIf="r.negotiation_count > 0"
                  class="btn btn-outline-info btn-sm"
                  type="button"
                  (click)="negotiatePrice(r)"
                >
                  <span class="kt-badge kt-badge--outline kt-badge--brand">{{
                    r.negotiation_count
                  }}</span>
                  {{ 'QUOTE_STATUS.PRICE_REQUEST' | translate }}
                </button>
                <h6 class="text-center">
                  {{ 'QUOTE_STATUS.EXPIRES_ON' | translate }} <br />
                  <strong class="text-success">
                    {{ r.expiry_dt | date: 'longDate' }}
                  </strong>
                </h6>
              </td>
              <td class="actions text-center">
                <a
                  *ngIf="r.variant_quotations_count > 0"
                  class="text-info mb-2"
                  title="Variant Quotes"
                  (click)="viewVariantQuotes(r)"
                  href="javascript:;"
                >
                  <span
                    class="kt-badge kt-badge--outline kt-badge--brand kt-badge--lg mb-2"
                  >
                    <strong> {{ r.variant_quotations_count }} </strong></span
                  >
                </a>
                <br />
                <div ngbDropdown class="d-inline-block">
                  <button
                    ngbDropdownToggle
                    mat-mini-fab
                    type="button"
                    color="default"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i class="flaticon-more-1"></i>
                  </button>

                  <div ngbDropdownMenu aria-labelledby="action-button">
                    <a
                      href="javascript:;"
                      title="{{ 'TEXT.EDIT_RECORD' | translate }}"
                      ngbDropdownItem
                      class="text-success"
                      (click)="showQuotationForm(r)"
                    >
                      <i class="fas fa-edit text-success"></i>
                      {{ 'BUTTONS.EDIT_QUOTATION' | translate }}
                    </a>
                    <a
                      href="javascript:;"
                      title="{{ 'TEXT.DELETE_RECORD' | translate }}"
                      ngbDropdownItem
                      class="text-danger"
                      (click)="delete(r)"
                    >
                      <i class="fas fa-trash text-danger"></i>
                      {{ 'BUTTONS.DELETE_QUOTATION' | translate }}
                    </a>

                    <!-- <a *ngIf="rfq.product_has_variants == 1 && (r.variant_quote_type == 1 || r.variant_quote_type == 3)" -->
                    <a
                      *ngIf="rfq.product_has_variants == 1"
                      href="javascript:;"
                      title="{{ 'BUTTONS.NEW_VARIANT_QUOTATION' | translate }}"
                      ngbDropdownItem
                      class="text-primary"
                      (click)="newVariantQuote(r)"
                    >
                      <i class="fas fa-plus text-primary"></i>
                      {{ 'BUTTONS.NEW_VARIANT_QUOTATION' | translate }}
                    </a>

                    <a
                      *ngIf="r.variant_quotations_count > 0"
                      ngbDropdownItem
                      class="text-info"
                      (click)="viewVariantQuotes(r)"
                      href="javascript:;"
                    >
                      <span class="kt-badge kt-badge--outline kt-badge--brand">
                        <strong> {{ r.variant_quotations_count }} </strong></span
                      >
                      &nbsp; {{ 'QUOTE_STATUS.VARIANT_QUOTES' | translate }}
                    </a>
                  </div>
                </div>

                <!-- <div>
                                    <a href="javascript:;" title="{{ 'TEXT.EDIT_RECORD' | translate }}"
                                        class="text-success" (click)="showQuotationForm(r)">
                                        <i class="fas fa-edit"></i> {{ 'BUTTONS.EDIT_VARIANT_QUOTATION' | translate }}
                                    </a>
                                    <a href="javascript:;" title="{{ 'TEXT.DELETE_RECORD' | translate }}"
                                        class="text-danger" (click)="delete(r)">
                                        <i class="fas fa-trash"></i> {{ 'BUTTONS.DELETE_VARIANT_QUOTATION' | translate }}
                                    </a>

                                    <a href="javascript:;" title="{{ 'BUTTONS.NEW_VARIANT_QUOTATION' | translate }}"
                                        class="text-primary" (click)="newVariantQuote(rfq, r)">
                                        <i class="fas fa-plus"></i> {{ 'BUTTONS.NEW_VARIANT_QUOTATION' | translate }}
                                    </a>

                                    <button *ngIf="r.variant_quotations_count > 0" class="btn btn-outline-info btn-sm" type="button"
                                            (click)="viewVariantQuotes(rfq, r)">
                                            <span class="kt-badge kt-badge--outline kt-badge--brand">{{ r.variant_quotations_count }}</span>
                                            {{ "QUOTE_STATUS.VARIANT_QUOTES" | translate }}
                                        </button>
                                </div> -->
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <mat-paginator
        [length]="qRecord.total"
        [pageSize]="qRecord.per_page"
        [pageSizeOptions]="pageSizeOptions"
        (page)="getRecords($event)"
      >
      </mat-paginator>
    </kt-portlet-body>
  </div>
</div>
